var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Zone Services"}},[_c('Countries'),_c('Zones')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }